import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@headlessui/react';
import { FormInput } from './FormInput';

interface DuplicateBudgetDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  defaultName?: string;
}

export const DuplicateBudgetDialog: React.FC<DuplicateBudgetDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  defaultName = '',
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState(defaultName);

  const handleConfirm = () => {
    if (name.trim()) {
      onConfirm(name);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-10 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center">
        <div
          className="fixed inset-0 bg-black bg-opacity-30 dark:bg-opacity-50"
          aria-hidden="true"
        />

        <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-8 dark:bg-gray-800">
          <Dialog.Title className="mb-4 text-lg font-medium text-gray-900 dark:text-white">
            {t('budget.duplicate')}
          </Dialog.Title>

          <div className="space-y-4">
            <FormInput
              label={t('budget.name')}
              value={name}
              onChange={(value) => setName(value as string)}
              placeholder={t('budget.name')}
            />

            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
              >
                {t('common.cancel')}
              </button>
              <button
                type="button"
                onClick={handleConfirm}
                data-attr="duplicate-budget-dialog-confirm-button"
                className="rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-500 dark:hover:bg-indigo-600"
              >
                {t('common.confirm')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
